/**
 * 天启埋点
 * https://target.hellobike.cn/#/buryingManager/pageModule/details?id=9888&eventType=page
 */
const cardLimitPageId = 'finance_loan_CardLimitPage';

// 臻有钱-双融担提现-卡单页-曝光
export const cardLimitPageExpose = `${cardLimitPageId}_expose`;

// 臻有钱-双融担提现-卡单页-资方模块点击
export const cardLimitPageCapitalModuleClick = `${cardLimitPageId}_capital_module_click`;

// 臻有钱-双融担提现-卡单页-提现协议模块点击
export const cardLimitPageLoanAgreementModuleClick = `${cardLimitPageId}_loanAgreement_Module_click`;

// 臻有钱-双融担提现-卡单页-还款计划模块点击
export const cardLimitPageRepaymentModuleClick = `${cardLimitPageId}_repayment_Module_click`;

// 臻有钱-双融担提现-卡单页-点击权益详情入口
export const cardLimitPageRightsDetailClick = `${cardLimitPageId}_rights_detail_click`;

// 臻有钱-双融担提现-卡单页-查看权益协议
export const cardLimitPageRightsAgreement = `${cardLimitPageId}_rights_agreement`;

// 臻有钱-双融担提现-卡单页-勾选权益协议按钮
export const cardLimitPageRightsAgreementCheck = `${cardLimitPageId}_rights_agreementCheck`;

// 臻有钱-双融担提现-卡单页-点击提交权益订单
export const cardLimitPageButton = `${cardLimitPageId}_button`;

// 臻有钱-双融担提现-卡单页-借款协议弹窗-曝光
export const cardLimitPageLoanAgreementPopExpose = `${cardLimitPageId}_loan_agreement_Pop_expose`;

// 臻有钱-双融担提现-卡单页-借款协议弹窗-点击
export const cardLimitPageLoanAgreementPopClick = `${cardLimitPageId}_loan_agreement_Pop_click`;

// 臻有钱-双融担提现-卡单页-异常提示弹窗-曝光
export const cardLimitPageErrorPopExpose = `${cardLimitPageId}_error_Pop_expose`;

// 臻有钱-双融担提现-卡单页-异常提示弹窗-点击
export const cardLimitPageErrorPopClick = `${cardLimitPageId}_error_Pop_click`;
